import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IChatMessage, IChatOutgoingMessage } from '@cakeiteasy/web-utils';

import { OrderOverviewApiService } from './order-overview-api.service';
import { IChatConversationGateway } from '../../order-chat/services/chat-conversation-gateway';

/**
 * Binds the arg-less conversation port to the order chat endpoints, which address the
 * conversation by order id.
 */
@Injectable()
export class OrderOverviewChatGateway implements IChatConversationGateway {
  public orderId: string;

  constructor(private _api: OrderOverviewApiService) {
  }

  public getMessages(): Observable<IChatMessage[]> {
    return this._api.getMessages(this.orderId);
  }

  public markRead(): Observable<void> {
    return this._api.markRead(this.orderId);
  }

  public sendMessage(message: IChatOutgoingMessage): Observable<IChatMessage[]> {
    return this._api.sendMessage(this.orderId, message);
  }
}
